module.exports = __webpack_public_path__ + "img/lab.f6c6d615.png";